import { useQuery } from "@tanstack/react-query";
import { DEPARTMENTS } from "@/data/mock";
import { withLatency } from "./simulate";

export async function fetchDepartments() {
  return withLatency(DEPARTMENTS);
}

export function useDepartments() {
  return useQuery({ queryKey: ["departments"], queryFn: fetchDepartments, staleTime: 60_000 });
}
